import { IMPLEMENTATION_GUIDE_API_BASE_URL } from "@/components/ImplementationGuide/constants";
import {
  FormSlug,
  ImplementationGuideFormData,
} from "@/components/ImplementationGuide/types";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useImplementationGuideSummaryGet = (districtUniqueId: string) => {
  const fullImplementationGuideApiUrl = `${MONOLITH_ORIGIN}${IMPLEMENTATION_GUIDE_API_BASE_URL}${districtUniqueId}/summary/`;

  return useRestQuery<Record<FormSlug, ImplementationGuideFormData>>(
    fullImplementationGuideApiUrl,
    { skip: !districtUniqueId },
  );
};

export default useImplementationGuideSummaryGet;
